import axios from 'axios';

export default class BrandingService {

  static createBranding(title: string, imageFormData: FormData, imageFormDataWhite: FormData) {

    return new Promise((resolve, reject) => {
      axios
        .post('/brandingUpload',
              imageFormData,
              { headers: {'Content-Type': 'multipart/form-data' }})
        .then((res) => {
              const image = res.data.file;
              axios
                .post('/brandingUploadWhite',
                  imageFormDataWhite,
                  { headers: {'Content-Type': 'multipart/form-data' }})
                .then((resWhite) => {
                  const coverImage = resWhite.data.file;
                  axios
                    .post('/brandings', { title, image, coverImage })
                    .then((res) => {
                      resolve(res.data);
                    })
                })
          })
        .catch(error => reject(error));
    });
  }

  static updateBranding(id: number, title: string, imageFormData?: FormData, imageFormDataWhite?: FormData) {

    if (imageFormData && imageFormDataWhite) {

      return new Promise((resolve, reject) => {
        axios
          .post('/brandingUpload',
                imageFormData,
                { headers: {'Content-Type': 'multipart/form-data' }})
          .then((res) => {
                const image = res.data.file;
                axios
                  .post('/brandingUploadWhite',
                    imageFormDataWhite,
                    { headers: {'Content-Type': 'multipart/form-data' }})
                  .then((resWhite) => {
                    const coverImage = resWhite.data.file;
                    axios
                      .put('/brandings', { id, title, image, coverImage })
                      .then((res) => {
                        resolve(res.data);
                      })
                  })
            })
          .catch(error => reject(error));
      });
    } else if (imageFormData) {

      return new Promise((resolve, reject) => {
        axios
          .post('/brandingUpload',
                imageFormData,
                { headers: {'Content-Type': 'multipart/form-data' }})
          .then((res) => {
                const image = res.data.file;
                axios
                  .put('/brandings', { id, title, image })
                  .then((res) => {
                    resolve(res.data);
                  })
            })
          .catch(error => reject(error));
      });
    } else if (imageFormDataWhite) {

      return new Promise((resolve, reject) => {
        axios
          .post('/brandingUploadWhite',
                imageFormDataWhite,
                { headers: {'Content-Type': 'multipart/form-data' }})
          .then((res) => {
                const coverImage = res.data.file;
                axios
                  .put('/brandings', { id, title, coverImage })
                  .then((res) => {
                    resolve(res.data);
                  })
            })
          .catch(error => reject(error));
      });
    } else {

      return new Promise((resolve, reject) => {
        axios
          .put('/brandings', { id, title })
          .then((res) => {
            resolve(res.data);
          })
          .catch(error => reject(error));
      });
    }
  }

  static deleteBranding(id: number) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/brandings/${id}`)
        .then((res) => {
          resolve(id);
        })
        .catch(error => reject(error));
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/BrandingService.ts